var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import randomstring from 'randomstring';
import { encode as base64encode } from './array';
import { readFromLocalStorage } from './storage';
import { localStorageKeys } from '@/constants/storage';
export function generateCodeChallenge() {
    return __awaiter(this, void 0, void 0, function* () {
        const codeVerifier = randomstring.generate(128);
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const digest = yield window.crypto.subtle.digest('SHA-256', data);
        const base64Digest = base64encode(digest);
        const codeChallenge = base64Digest
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=/g, '');
        return { codeChallenge, codeVerifier };
    });
}
export function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window
        .atob(base64)
        .split('')
        .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
    return JSON.parse(jsonPayload);
}
export const isUserAuthenticated = () => __awaiter(void 0, void 0, void 0, function* () {
    const accessToken = yield readFromLocalStorage(localStorageKeys.ACCESS_TOKEN);
    const refreshToken = yield readFromLocalStorage(localStorageKeys.REFRESH_TOKEN);
    if (accessToken && refreshToken) {
        return true;
    }
    return false;
});
